import { StyledFooter as StyledMainFooter } from 'components/layout/footer/Footer.styled';
import { rgba } from 'polished';
import styled from 'styled-components';
import { color, container, fontSize, fontWeight, screen, spacing } from 'theme';
import { getPublicPath } from 'utils/paths';

export const StyledFooter = styled.footer`
  background-color: ${color('midnight_900')};
  background-image: linear-gradient(
      ${rgba('#1f1d26', 0.75)},
      ${rgba('#1f1d26', 0.75)}
    ),
    url('${getPublicPath('/images/stateSector/hero-bg.gif')}');
  background-size: cover;
  padding-top: 5rem;
  color: ${color('text_default_inverse')};

  @media (min-width: ${screen('lg')}) {
    padding-top: 10rem;
  }

  ${StyledMainFooter} {
    background: transparent;
  }
`;

export const StyledFooterContainer = styled.div`
  max-width: ${container('xlMax')};
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledFooterNavCopy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing('md')};
  margin-top: ${spacing('md')};
  @media (min-width: ${screen('md')}) {
    flex-direction: row-reverse;
  }
`;

export const StyledFooterLogo = styled.div`
  flex-shrink: 0;
  img {
    display: block;
    width: 17rem;
    height: auto;
  }
  p {
    text-align: center;
    font-size: ${fontSize('xl')};
    line-height: 1.57;
    margin-top: ${spacing('md')};
    margin-bottom: 0;
  }
`;

export const StyledFooterCta = styled.div`
  margin-top: 1.25rem;
  margin-bottom: ${spacing('xl3')};
`;

export const StyledFooterCopyright = styled.small`
  text-align: center;
  font-size: ${fontSize('xs')};
  font-weight: ${fontWeight('medium')};

  strong {
    font-weight: ${fontWeight('black')};
  }
`;
